// Turns the private timeline into shareable, generic milestones (labels + dates only).
export function journeyFromTimeline(items, t, lang) {
  const asc = [...(items || [])].sort((a, b) => new Date(a.date) - new Date(b.date));
  const fmt = (d) => new Date(d).toLocaleDateString(lang === "IT" ? "it-IT" : "en-GB", { day: "numeric", month: "short" });
  const steps = [];
  let decisions = 0, lastDecisionDate = null;
  const flushDecisions = () => {
    if (decisions) { steps.push({ date: fmt(lastDecisionDate), label: t("share.j_decisions").replace("{n}", decisions) }); decisions = 0; }
  };
  const arrow = (s) => (s && s.previous != null && s.new != null && s.previous !== s.new ? ` · ${s.previous} → ${s.new}` : "");
  for (const it of asc) {
    if (it.kind === "decision") { decisions += 1; lastDecisionDate = it.date; continue; }
    flushDecisions();
    const map = {
      created: t("share.j_captured"),
      analysis: t("share.j_analysis").replace("{n}", it.score?.new ?? "—"),
      evidence: t("share.j_evidence") + arrow(it.score),
      evidence_removed: t("share.j_evidence_removed") + arrow(it.score),
      update: t("share.j_update") + arrow(it.score),
      move_started: t("share.j_move_started"),
      move_completed: t("share.j_move_completed"),
      maturity: t("share.j_maturity").replace("{m}", t(`maturity.${it.maturity}`)),
    };
    if (map[it.kind]) steps.push({ date: fmt(it.date), label: map[it.kind] });
  }
  flushDecisions();
  const scores = asc.filter((i) => i.score?.new != null).map((i) => i.score.new);
  const first = asc[0]?.date;
  const days = first ? Math.max(1, Math.floor((Date.now() - new Date(first)) / 86400000)) : 1;
  const trimmed = steps.length > 8 ? [steps[0], ...steps.slice(-7)] : steps;
  return { steps: trimmed, scores, days };
}
